const Reward = () => {
  return <div>Rewards</div>;
};

export default Reward;
